// User-facing product name. Isolated from the env-schema module so it can be
// imported from browser bundles (add-in) without pulling in server-only env
// validation. Change here to rebrand every visible touch-point (task pane,
// manifest, HTML title, auth pages) in one shot. Internal identifiers
// (@bigpp/* package names, DOM/storage-key prefixes) intentionally keep the
// historical name.
export const BRAND = "PowerSlide";
